import { IconSvg, type IconSvgProps } from '../components/IconSvg';

export function CloseAlt(props: IconSvgProps) {
  return (
    <IconSvg size={30} viewBox="0 0 30 30" {...props}>
      <path d="M20.2344 11.5234L16.7578 15L20.2344 18.5156L21.1328 19.375L19.375 21.1719L18.4766 20.2734L15 16.7969L11.4844 20.2734L10.625 21.1719L8.82812 19.375L9.72656 18.5156L13.2031 15L9.72656 11.5234L8.82812 10.625L10.625 8.86719L11.4844 9.76562L15 13.2422L18.4766 9.76562L19.375 8.86719L21.1328 10.625L20.2344 11.5234Z" />
    </IconSvg>
  );
}
